import AuthService from '../../utilities/services/auth.service'
import { RevenueInsightsWrapper } from '../../components'

export default function RevenueInsightsPage() {
  const organization = AuthService.getOrg()[0]
  return <RevenueInsightsWrapper organization={organization} />
}
